import { MAIN_CONTENT_ID } from '@/components/accessibility/SkipToMain';
import Hero from '@/components/discountLanding/Hero';
import Invest from '@/components/discountLanding/Invest';
import Testimonials from '@/components/discountLanding/Testimonials';
import Unlock from '@/components/discountLanding/Unlock';
import Header from '@/components/header/Header';
import { useAnalytics } from '@/hooks/analytics';
import { useDeviceState, usePricesState } from '@/hooks/store';
import { useRouterPush } from '@/hooks/utils/useRouterPush';

import { getActiveOffer } from '../utils/getActiveOffer';
import { OnCtaClick } from './types';

const DiscountLandingWrapper = ({ welcomeText }: { welcomeText?: string }) => {
	const { logEvent } = useAnalytics();
	const prices = usePricesState();
	const routerPush = useRouterPush();

	const activeOffer = getActiveOffer(prices, useDeviceState());
	const isDiscounted = activeOffer !== null;

	const onClick: OnCtaClick = async ({ section, copy }) => {
		logEvent({
			eventName: 'New Member Offer: CTA : Clicked',
			eventProps: {
				section,
				copy,
				type: 'button',
				coupon: activeOffer?.couponId ?? null,
				offer_type: activeOffer?.type ?? null,
			},
		});

		await routerPush(isDiscounted ? '/special-welcome-offer' : '/signup-flow');
	};

	return (
		<main id={MAIN_CONTENT_ID}>
			<Header isStatic hideMenu hideProfile />
			<Hero isDiscounted={isDiscounted} onClick={onClick} welcomeText={welcomeText} />
			<Invest onClick={onClick} />
			<Unlock isDiscounted={isDiscounted} onClick={onClick} />
			<Testimonials onClick={onClick} />
		</main>
	);
};

export default DiscountLandingWrapper;
